import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserProfileService } from 'src/app/_services/user-profile.service';
import { UserProfile } from 'src/app/_models/user-profile';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PortalApps } from 'src/app/_models/portal-routes';
import { NavLinkAvailabilityService } from 'src/app/_services/nav-link-availability.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { Router } from '@angular/router';
import { PortalReportsService } from '../../_services/portal-reports.service';
import { ReportGroup } from '../../_models/reports';
import { ConfigurationService } from '../../_services/configuration.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  userProfile: UserProfile;
  reportServer: string = '';
  appsAvailable: PortalApps[];
  favoriteReports: ReportGroup;
  allFavoritesVisible: boolean = false;
  isLoadingReports: boolean = false;
  showDashboards: boolean = false;
  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(
    private userService: UserProfileService,
    private configurationService: ConfigurationService,
    private navLinksService: NavLinkAvailabilityService,
    private permissionsService: NgxPermissionsService,
    private reportsService: PortalReportsService,
    private titleService: Title,
    private router: Router
  ) {
    this.userService.userProfile$.pipe(takeUntil(this.onDestroy$)).subscribe(
      userProfile => { this.userProfile = userProfile });

    this.reportServer = this.configurationService.config.reportViewerAddress;
    this.showDashboards = this.configurationService.config.showDashboards;
    this.configurationService.configData$.subscribe(res => {
      this.reportServer = res.reportViewerAddress;
      this.showDashboards = res.showDashboards;
    })

    this.navLinksService.availableLinks$.pipe(takeUntil(this.onDestroy$)).subscribe(
      availableLinks => { this.appsAvailable = availableLinks });

    this.reportsService.isLoadingReports$.pipe(takeUntil(this.onDestroy$)).subscribe(
      loadingStatus => { this.isLoadingReports = loadingStatus });

    this.reportsService.favoriteReports$.pipe(takeUntil(this.onDestroy$)).subscribe(
      reports => { this.favoriteReports = reports });

    this.permissionsService.hasPermission(["SUPERADMIN", "CONTROLPANELADMIN"]).then((result) => {
      if (!result) {
        /* Redirect non control panel admins to Portal temporarily */
        this.router.navigate(['/app/Portal/reportlist']);
        console.log('Redirect to Portal');
      }
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle('Homepage - Productioneer Portal');
    this.reportsService.loadReportList();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  showAllFavorites() {
    this.allFavoritesVisible = true;
  }

  openUserPage() {
    this.router.navigate(['/app/ControlPanel/users/user/' + this.userProfile.name]);
  }
}
